import { gql } from '@apollo/client';

export const CREATE_PAYMENT = gql`
  mutation createPayment($input: PaymentInput!) {
    createPayment(input: $input) {
      id
    }
  }
`;

export const VALIDATE_PAYMENT = gql`
  query validatePayment($input: PaymentInput!) {
    validatePayment(input: $input)
  }
`;

export const VALIDATE_REFUND = gql`
  query validateRefund($input: RefundPaymentInput!) {
    validateRefund(input: $input)
  }
`;

export const REJECT_PAYMENT = gql`
  mutation refundPayment($input: RefundPaymentInput!) {
    refundPayment(input: $input) {
      id
      sum
      is_refunded
    }
  }
`;

export const POST_PAYMENT_CONFIRM = gql`
  mutation ProcessPostPayment(
    $processPostPaymentId: Int!
    $input: ProcessPostPaymentInput!
  ) {
    processPostPayment(id: $processPostPaymentId, input: $input) {
      id
      method
      status
    }
  }
`;

export const POST_PAYMENT_COUNT = gql`
  query getPostPaymentCount {
    activeWorkShift {
      payments {
        id
        method
        status
      }
    }
  }
`;
